import { Container, Divider, Grid, Typography } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';

export default function AboutPage() {

     return (
        <Container>
            <Typography gutterBottom variant="h3" align="center">Home Base Enamels</Typography>
            <Divider sx={{mb: 4}}/>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={7} sx={{mb: 2}}>
                        <Typography sx={{mb: 2}} variant="body1" align="justify">
                        My name is Karen Ellis. Being creative has always been my happy place and after many years of varied artistic pursuits I wanted to try enamelling. This has resulted in a obsession which has led me down a wonderful never ending rabbit hole of exploration and expression. The alchemy of fusing glass to metal with no two pieces ever being exactly the same is fascinating and drives me to keep developing as an enamel artist. For years I have fired my enamels with a torch but have recently purchased a kiln and am enjoying extending my repertoire of enamelling techniques.
                        </Typography>
                        
                        <Typography sx={{mb: 2}} variant="body1" align="justify">
                        I love playing with colour and pattern and making bright colourful artisanal jewellery that people will love wearing.
                        </Typography>
                        
                        <Grid container>
                          <Grid item xs={12} sx={{mb: 0}}> 
                            <Typography variant="body1" align="justify">
                            You can follow me on Instagram:
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sx={{mb: 2}}> 
                            <InstagramIcon
                            onClick={() => window.open(`https://www.instagram.com/home_base_enamels/`)}
                            fontSize="large"
                            sx={{ mt: 1}}
                            />
                          </Grid>
                        </Grid>                                                                              
                      </Grid>
                  <Grid item xs={12} md={5} sx={{mb: 2}}>
                      <img 
                          src="https://res.cloudinary.com/dqngoafsr/image/upload/v1696374733/HomeBaseGallery/s8rtlf23l9xdjquwk6oz.jpg" 
                          alt="karen" 
                          style={{
                              width: '100%',
                              objectFit: 'fill',
                              display: 'inline-block',
                              borderRadius: '8px',
                              filter: 'drop-shadow(11px 3px 15px #5b6566)'
                          }}/>
                  </Grid>
                </Grid>
        </Container>
    )
}